import { lazy } from "react";
import { AdvanceMODAL } from "redux/slices/advanceModal";


const TanfeetiForm = lazy(() => import("./TanfeetiForm"));

export { default } from "./AdvanceModal";

export type AdvanceModalMapper = {
  [key in AdvanceMODAL]: "" | JSX.Element;
};

export const advanceModalMapper: AdvanceModalMapper = {
  TANFEETIFORM: <TanfeetiForm />,
};
